// NPM imports

import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';

// import reducers

import auth from './auth';
import suggestion from './suggestion';

import operationalDashboardConfiguration from './operational-dashboard-configuration';
import operationalDashboardDistribution from './operational-dashboard-distribution';
import operationalDashboardWarehouse from './operational-dashboard-warehouse';
import operationalDashboardVehicles from './operational-dashboard-vehicles';

import dashboardCompleted from './dashboard-completed';
import dashboardHome from './dashboard-home';
import dashboardForecast from './dashboard-forecast';
import dashboardFilters from './dashboard-filters';
import dashboardRealTime from './dashboard-real-time';

import customer from './customer';
import region from './region';
import shippingCompany from './shipping-company';
import shippingGroup from './shipping-group';

import availableVehicles from './available-vehicles';
import manifestsInTransit from './manifests-in-transit';
import manifest from './manifest';

import adminPlatformUsers from './admin-platform-users';
import adminCompanies from './admin-companies';
import adminLuftUsers from './admin-luft-users';
import adminNotificationSettings from './admin-notification-settings';

import stock from './stock';

import tracking from './tracking';
import deliveryStatus from './delivery-status';
import scheduling from './scheduling';
import newSchedule from './new-schedule';
import trackingManager from './tracking-manager';
import recipientTracking from './recipient-tracking';

import receipts from '../pages/Receipts/receipts-store';
import carbon from './carbon';
import notesConnection from './note-connection'

const rootReducer = combineReducers({
  auth,
  suggestion,
  dashboardCompleted,
  dashboardHome,
  dashboardForecast,
  dashboardFilters,
  dashboardRealTime,
  customer,
  availableVehicles,
  manifest,
  manifestsInTransit,
  region,
  shippingCompany,
  shippingGroup,
  adminPlatformUsers,
  adminCompanies,
  adminLuftUsers,
  adminNotificationSettings,
  tracking,
  form,
  deliveryStatus,
  stock,
  scheduling,
  newSchedule,
  receipts,
  operationalDashboardConfiguration,
  operationalDashboardDistribution,
  operationalDashboardWarehouse,
  operationalDashboardVehicles,
  trackingManager,
  recipientTracking,
  carbon,
  notesConnection
});

export default rootReducer;
